import { Injector } from '@angular/core';
import { I18NextLoadResult } from 'angular-i18next';
import { I18nService } from '../services/i18n.service';

/**
 * Returns a function that loads the i18n resources using the provided injector.
 * The returned function is a promise that resolves to an I18NextLoadResult.
 *
 * @param injector - The injector used to retrieve the I18nService.
 * @returns A function that loads the i18n resources.
 */
export function I18nLoader(injector: Injector): () => Promise<I18NextLoadResult> {
  return () => injector.get(I18nService).init();
}
